import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarIcon from "../../../assets/icons/CalenderIcon.svg";

const DateInput = ({ label, value, onChange }) => {
  const dateInputRef = useRef(null);

  const handleButtonClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.setOpen(true);
    }
  };

  return (
    <div className="date-field d-flex align-items-center gap-1 pb-1 position-relative">
      <DatePicker
        selected={value}
        ref={dateInputRef}
        onChange={onChange}
        className="dashboard-date-picker"
        placeholderText={label}
        dateFormat="yyyy-MM-dd" // Correct format
        onKeyDown={(e) => e.preventDefault()}
        maxDate={new Date()} // Disable future dates
      />
      <img
        src={CalendarIcon}
        alt="Calendar Icon"
        className="dashboard-date-picker-icon"
        onClick={handleButtonClick}
      />
    </div>
  );
};

export default DateInput;
